import AlbumPage from "@/views/albums/AlbumPage.vue";
import AlbumNewPage from "@/views/albums/AlbumNewPage.vue";
import AlbumEditPage from "@/views/albums/AlbumEditPage.vue";

export default [
    // /albums/new
    {
        path: '/albums/new',
        name: 'AlbumNewPage',
        component: AlbumNewPage,
    },
    // /albums/:id
    {
        path: '/albums/:id',
        name: 'AlbumPage',
        component: AlbumPage,
    },
    // /albums/:id/edit
    {
        path: '/albums/:id/edit',
        name: 'AlbumEditPage',
        component: AlbumEditPage,
    },
]